import Vue from "vue";
import VueI18n from "vue-i18n";
//引入自定义语言配置
import developZh from './zh';
import developEn from './en';

Vue.use(VueI18n);
const i18n = new VueI18n({
 locale: localStorage.lang || "zh",
 messages: {
   'zh': {
     ...developZh
   },   // 中文语言包
   'en': {
     ...developEn
   }   //英文语言包
 }
});
export default i18n;
